import { combineReducers } from "redux";
import { walletReducer } from "./_walletReducer";

export default combineReducers({
  wallet: walletReducer,
});
